module.exports = __webpack_public_path__ + "static/img/lres4.8064943.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/lres4.png
// module id = nDMK
// module chunks = 1